module.exports = __webpack_public_path__ + "img/yuanqu.04b6a153.jpg";